import React from "react";
import clsx from "clsx";
import "flag-icons/css/flag-icons.min.css";

// Renders a country flag from the flag-icons sprite. `code` is an ISO 3166-1 alpha-2 code.
export default function FlagIcon({ code, squared = false, className, ...rest }) {
  return <span className={clsx("fi", `fi-${String(code).toLowerCase()}`, squared && "fis", className)} {...rest} />;
}
